import type { Job } from '../model';

/**
 * The design's first page, in a square of the given size (SLD-0004).
 *
 * The image is fitted, not cropped: a stitch design is read by its shape, and
 * a thumbnail that cut the edge off would show a different design. A job with
 * no thumbnail yet shows a blank square of the same size, so the rows line up
 * whether or not the design has been drawn.
 */
export function Thumbnail({ job, size, className = '' }: {
  job: Pick<Job, 'name' | 'thumbnailUrl'>;
  /** The square's side in CSS pixels; `undefined` fills its container. */
  size?: number;
  className?: string;
}) {
  const style = size ? { width: size, height: size } : undefined;
  if (!job.thumbnailUrl) {
    return <div className={`thumb thumb-empty ${className}`} style={style}
                title="No preview yet" aria-hidden="true" />;
  }
  return (
    <div className={`thumb ${className}`} style={style}>
      <img src={job.thumbnailUrl} alt={`First page of ${job.name}`} />
    </div>
  );
}
